import { useSessionContext } from "../../contexts";
import { sunboundPayProxy } from "../../proxies";
import { PaymentType } from "../../components/shared/enums";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

// TODO replace this with a community setting API PDE-687
const HIDE_CREDIT_CARD_PAYMENT_COMMUNITY_IDS: string[] = [
  "102",
  "103",
  "104",
  "108",
  "109",
  "110",
  "112",
  "114",
  "115",
  "116",
  "121",
];

const getCommunityId = async (idAccount: string): Promise<string> => {
  try {
    const tasks = await sunboundPayProxy.getGuarantorTasks(idAccount);
    const communityId = (
      tasks?.currentBill?.account?.community?.idCommunity ?? ""
    ).toString();

    if (communityId) return communityId;
  } catch (e) {
    console.error;
  }

  try {
    const tasks = await sunboundPayProxy.getPayorTasks(idAccount);
    const communityId = (
      tasks?.currentBill?.account?.community?.idCommunity ?? ""
    ).toString();

    return communityId;
  } catch (e) {
    console.error(e);
  }

  return "";
};

export const useAllowedPaymentTypes = (): {
  allowedPaymentTypes: PaymentType[];
  isLoading: boolean;
  isError: boolean;
} => {
  const session = useSessionContext();
  const location = useLocation();
  const [communityId, setCommunityId] = useState<string>();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const loadedCommunityId = (
      session?.session?.idCommunity ??
      location?.state?.currentBill?.account?.community?.idCommunity
    )?.toString?.();

    if (loadedCommunityId) {
      setCommunityId(loadedCommunityId);
      setIsLoading(false);
      setIsError(false);
      return;
    }

    const idAccount: string = session?.session?.idAccount || "";
    if (!idAccount) {
      setIsLoading(false);
      setIsError(true);
      return;
    }

    setIsLoading(true);

    (async () => {
      try {
        const communityId = await getCommunityId(idAccount);
        setCommunityId(communityId);
        setIsError(false);
      } catch (error) {
        console.error(error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [location, session]);

  const value = useMemo(() => {
    const allowCreditCard =
      !!communityId &&
      !HIDE_CREDIT_CARD_PAYMENT_COMMUNITY_IDS.includes(communityId);
    return {
      allowedPaymentTypes: allowCreditCard
        ? [PaymentType.ACH, PaymentType.Card]
        : [PaymentType.ACH],
      isError,
      isLoading,
    };
  }, [isError, isLoading, communityId]);

  return value;
};
